import { render, staticRenderFns } from "./CtasBancosProveedoresEdit.vue?vue&type=template&id=4906defc&"
import script from "./CtasBancosProveedoresEdit.vue?vue&type=script&lang=js&"
export * from "./CtasBancosProveedoresEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports